import { FC, Fragment } from 'react';
// Types
import QuizTypes from 'types/QuizTypes';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';

const LandingPage:FC = () => {
  // State
  const quiz:IQuiz = useAppSelector(selectQuiz);

  const { landingPage } = quiz;

  if ( !quiz || quiz.type === QuizTypes.Scoring ) return null;

  const callToAction = landingPage && landingPage.callToAction;

  return (
    <Fragment>
      {callToAction && callToAction.image ? (
        callToAction.url ? (
          <a
            className="block shadow-neu-content rounded mb-4 overflow-hidden"
            href={callToAction.url}
            target="_blank"
            rel="noreferrer"
          ><img src={callToAction.image} alt={callToAction.text} /></a>
        ) : (
          <div
            className="block shadow-neu-content rounded mb-4 overflow-hidden"
          ><img src={callToAction.image} alt={callToAction.text} /></div>
        )
      ) : null}
      {callToAction && callToAction.text ? (
        <h3 className="text-center text-sm text-blue-500 font-bold mb-2 px-4">
          {callToAction.text}
        </h3>
      ) : null}
    </Fragment>
  )
}

export default LandingPage;
